import React, {useContext, useEffect, useState} from 'react'
import {MDBCol, MDBIcon, MDBInput, MDBRow} from "mdbreact";
import {Button, useTheme} from "@material-ui/core";

import ToastContext from "../context/toast.context";

import stackdLogo from '../assets/img/stackd-logo-title.png'
import svgLogin from '../assets/img/svg/login-svg.svg'

import {login} from '../model/user.model'

import {Alert} from "@material-ui/lab";

export default function LoginPage(){
    const [email, setEmail] = useState("")
    const [password, setPassword] = useState("")
    const [isValidate, setIsValidate] = useState(false)
    const [error, setError] = useState("")

    const [isPending, setIsPending] = useState(false)

    const {toast} = useContext(ToastContext)

    useEffect(()=>{
        setIsValidate(email!=="" && password!=="")
    }, [email, password])

    const handleSubmit = (event) =>{
        event.preventDefault();
        setIsPending(true)
        login(email, password)
            .then(()=>{
                toast.fire({icon: "success", title: "Vous êtes connecté"})
            })
            .catch(setError)
            .finally(()=>{setIsPending(false)})
    }

    const theme = useTheme();

    return(
        <div>
            <h3 style={{color: theme.palette.primary.main, fontFamily: "Montserrat, sans-serif", marginTop: "5rem", marginLeft: "3rem", position: "absolute"}}>
                <img src={stackdLogo} alt="logo-stackd" className="ml-3" style={{width: "40%"}}/>
            </h3>
            <MDBRow style={{marginLeft: "0px", marginRight: "0px", height: "100vh", justifyContent: "center", backgroundColor: "white"}}>
                <MDBCol md="1"/>
                <MDBCol md="4" className="container" style={{alignItems: "center", display: "grid"}}>
                    <MDBRow>
                        <MDBCol size="10">
                            {error !== "" && (
                                <div style={{marginTop: "2rem", marginBottom: "2rem"}}>
                                    <Alert variant="outlined" severity="error">
                                        {error}
                                    </Alert>
                                </div>
                            )}
                            <form onSubmit={handleSubmit}>
                                <h2 style={{textAlign: "center"}}>Connexion</h2>
                                <br/>

                                <MDBInput
                                    focused
                                    size="lg"
                                    label="Adresse e-mail"
                                    getValue={setEmail}
                                    icon="envelope"
                                    value={email}
                                    iconLight={true}
                                    type="email"
                                    style={{fontSize: "1.2rem"}}
                                />

                                <MDBInput
                                    size="lg"
                                    value={password}
                                    getValue={setPassword}
                                    label="Mot de passe"
                                    icon="lock"
                                    iconLight={true}
                                    type="password"
                                    style={{fontSize: "1.2rem"}}
                                />

                                <div className="text-center" style={{marginTop: "2rem"}}>
                                    <Button variant="contained" type="submit" color="primary" disabled={!isValidate} className="mt-3" size="large">
                                        Connexion {isPending && <MDBIcon icon="spinner" pulse className="ml-1" size="1x" fixed />}
                                    </Button>
                                </div>
                            </form>
                        </MDBCol>
                    </MDBRow>
                </MDBCol>
                <MDBCol md="6" style={{backgroundColor: theme.palette.primary.light, textAlign: "center", display: "flex"}}>
                    <img src={svgLogin} alt="login-svg" className="img-fluid" style={{margin: "auto"}}/>
                </MDBCol>
            </MDBRow>
        </div>
    );
}